import { render, staticRenderFns } from "./PendingWork.vue?vue&type=template&id=321b967e&scoped=true"
import script from "./PendingWork.vue?vue&type=script&lang=js"
export * from "./PendingWork.vue?vue&type=script&lang=js"
import style0 from "./PendingWork.vue?vue&type=style&index=0&id=321b967e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321b967e",
  null
  
)

export default component.exports